// src/native/components/google-calendar-header-item.jsx

import React from 'react'
import {
    ListSubHeader,
  } from 'react-toolbox/lib/list'
import {
Button,
} from 'react-toolbox/lib/button'
import Checkbox from 'react-toolbox/lib/checkbox'
import googleCalendarListTheme from './themes/google-calendar-list.css'
import moment from 'moment'


class GoogleCalendarHeaderItem extends React.Component {
    render(){
        const {
            t,
            key,
            event,
            copyCalendarEvents,
            toggleImportInfo,
            toggleTimeImportInfo,
            checked,
            checkedTime,
            selectDate,
            } = this.props
        return <ListSubHeader 
            theme={googleCalendarListTheme}
            caption={
            <div style={{ display: 'flex', marginTop: "30px" }}>
            <div style={{ color: 'black', fontWeight: 'bold' }}>{moment(selectDate).format('LLLL')}</div>
            {event && event.length > 0 &&
              <div style={{ display: 'flex', marginLeft: 'auto', flexDirection: 'row' }}>
                <div style={{ marginTop: 8, marginRight: 8 }}>
                  <Checkbox key="checkbox" checked={checked}
                  onChange={() => toggleImportInfo(selectDate)} label={t('label:説明を表示')} />
                </div>
                <div style={{ marginTop: 8, marginRight: 8 }}>
                  <Checkbox key="checkbox" checked={checkedTime}
                  onChange={() => toggleTimeImportInfo(selectDate)} label={t('label:時間を表示')} />
                </div>
                <Button primary
                  label={t('label:日報にコピー')} raised
                  theme={googleCalendarListTheme}
                  icon="content_copy"
                  onClick={() => copyCalendarEvents(selectDate, checked, checkedTime)} />
              </div>
            }
            </div>
        } />
    }
}

export default GoogleCalendarHeaderItem


// WEBPACK FOOTER //
// ./src/web/components/google-calendar-header-item.jsx